import {Space} from "antd";
import {motion, AnimatePresence} from "framer-motion";
import {SortCoachUpcomingCallsByTime} from "../../../../services/helpers";
import {useGetCoachUpcomingCallsContext} from "../../../../context/upcoming-calls/coach";
import {CoachUpcomingCallCard} from "../call-card/new";

const CallsSection = () => {
  const {
    state: {
      coachUpcomingCallsData: {transactions},
    },
  } = useGetCoachUpcomingCallsContext();

  return (
    <motion.div>
      <AnimatePresence>
        <Space direction="vertical" size={42} style={{display: "flex"}}>
          {SortCoachUpcomingCallsByTime(transactions).map((transaction) => (
            <CoachUpcomingCallCard key={transaction.id} transaction={transaction} />
          ))}
        </Space>
      </AnimatePresence>
    </motion.div>
  );
};

export {CallsSection};
